module.exports = __webpack_public_path__ + "static/img/join_13.17e5ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_13.jpg
// module id = D4HG
// module chunks = 1